// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3vW7w","subheader":"ReorderModal_subheader__1_NCE","listWrap":"ReorderModal_listWrap___fSsq"};